import React from 'react';
import { Dialog, DialogTitle, DialogContent, IconButton, Box, Typography, DialogActions } from '@mui/material';
import { Close } from '@mui/icons-material';
import { ReactComponent as CloseIcon } from "assets/close_icon.svg";

const CustomDialog = ({
    open,
    handleClose,
    title,
    sub_title,
    children,
    maxWidth = 'sm',
    fullWidth = true,
    fullHeight = false,
    actions,
    hideCloseButton = false,
    sx = {},
    ActionIcon = () => {
        return <></>
    },
    ...props
}) => {
    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth={maxWidth}
            fullWidth={fullWidth}
            PaperProps={{
                sx: {
                    // Paper margin/width/radius come from the MuiDialog theme override
                    // (DIALOG_MARGIN / DIALOG_RADIUS in themes/theme.js) — not here.
                    ...(fullHeight ? { height: "100dvh" } : {}),
                    // height: fullHeight ? "100dvh" : "inherit",
                    ...sx
                }
            }}
            {...props}
        >
            {/* pr leaves room for the absolutely-positioned close button */}
            <DialogTitle sx={{ p: { xs: 2, sm: 3 }, pb: 2, pr: { xs: '3.5rem', sm: '4rem' } }}>
                <Box display="flex" alignItems="center" justifyContent="space-between">
                    <Box>
                        <Typography variant="h6" sx={{ fontWeight: 600, color: '#101828' }}>
                            {title}
                        </Typography>
                        {sub_title && <Typography variant="subtitle2" gutterBottom>
                            {sub_title}
                        </Typography>}
                    </Box>
                    {!hideCloseButton ? (
                        <IconButton sx={{ position: "absolute", top: { xs: 12, sm: 20 }, right: { xs: 12, sm: 20 }, padding: 0 }}>
                            <CloseIcon width={40} height={40} onClick={handleClose} />
                        </IconButton>
                    ) : <div>
                        <ActionIcon />
                    </div>}
                </Box>
            </DialogTitle>
            <DialogContent sx={{ px: { xs: 2, sm: 3 }, py: 2, '& .MuiInputBase-root': { borderRadius: '8px' } }}>
                {children}
            </DialogContent>
            {actions && (
                <DialogActions sx={{ p: { xs: 2, sm: 3 }, pt: 2, '& .MuiButton-root': { borderRadius: '8px' } }}>
                    {actions}
                </DialogActions>
            )}
        </Dialog>
    );
};

export default CustomDialog;